import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./lib/AuthContext";
import MapPage from "./pages/MapPage";
import AdminPage from "./pages/AdminPage";
import VerifyEmailPage from "./pages/VerifyEmailPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import LegalPage from "./pages/LegalPage";
import ModerationPage from "./pages/ModerationPage";
import { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './components/ui/dialog';
import { Button } from './components/ui/button';

function App() {

const AGE_GATE_KEY = "urbsex.ageGateAccepted";

const [isAgeGateOpen, setIsAgeGateOpen] = useState(() => {
  try {
    return localStorage.getItem(AGE_GATE_KEY) !== "1";
  } catch {
    return true;
  }
});

const [isBlocked, setIsBlocked] = useState(false);

  if (isBlocked) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-[#1d191a] text-white">
        <div className="text-center space-y-4">
          <p className="text-lg font-medium">
            Accès refusé.
          </p>
          <p className="text-sm text-white/70">
            Cette application est réservée aux personnes majeures.
          </p>
        </div>
      </div>
    );
  }

  return (
    <AuthProvider>
      {isAgeGateOpen ? (
        <div className="min-h-screen bg-[#1d191a] flex flex-col">
          {/* Bandeau haut minimal */}
          <div className="bg-[#1d191a] border-b border-white/10 px-4 py-3">
            <div className="text-xl font-semibold text-white">
              UrbSex
            </div>
          </div>

          {/* Gate 18+ */}
          <div className="flex-1 flex items-center justify-center">
            <Dialog open={true}>
              <DialogContent className="max-w-md">
                <DialogHeader>
                  <DialogTitle className="text-xl">
                    Accès réservé aux majeurs
                  </DialogTitle>
                </DialogHeader>

                <div className="space-y-4 text-sm leading-relaxed mt-2">
                  <p>
                    Cette application est réservée aux personnes majeures.
                  </p>
                  <p className="font-medium">
                    En continuant, tu confirmes avoir 18 ans ou plus.
                  </p>
                </div>

                <div className="flex justify-end gap-2 mt-4">
                  <Button
                    variant="outline"
                    onClick={() => {
                      // Empêche l'accès : on sort de l'app (simple et efficace)
                      window.location.href = "about:blank";
                    }}
                  >
                    Annuler
                  </Button>

                  <Button
                    onClick={() => {
                    try {
                    localStorage.setItem(AGE_GATE_KEY, "1");
                    } catch {}
                    setIsAgeGateOpen(false);
                  }}
                    className="bg-amber-500 hover:bg-amber-600 text-black"
                  >
                    J’ai plus de 18 ans
                  </Button>

                </div>
              </DialogContent>
            </Dialog>
          </div>
        </div>
      ) : (
        <BrowserRouter>
          <Routes>
            {/* Map = plein écran + pas de scroll */}
            <Route
              path="/"
              element={
                <div className="h-screen w-screen overflow-hidden">
                  <MapPage />
                </div>
              }
            />
            <Route
      path="/spot/:id"
      element={
        <div className="h-screen w-screen overflow-hidden">
          <MapPage />
        </div>
      }
    />
    <Route path="/verify" element={<VerifyEmailPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />

            {/* Legal = doit scroller */}
            <Route
              path="/legal"
              element={
                <div className="min-h-screen w-full overflow-y-auto">
                  <LegalPage />
                </div>
              }
            />

            {/* Admin = doit scroller */}
            <Route
              path="/admin"
              element={
                <div className="min-h-screen w-full overflow-y-auto">
                  <AdminPage />
                </div>
              }
            />

            {/* Modération = doit scroller */}
            <Route
              path="/moderation"
              element={
                <div className="min-h-screen w-full overflow-y-auto">
                  <ModerationPage />
                </div>
              }
            />
          </Routes>

          <Toaster position="top-right" richColors toastOptions={{ duration: 1500 }} />
        </BrowserRouter>
      )}
    </AuthProvider>
  );
}

export default App;
